import { render, staticRenderFns } from "./tellaintlcjis.vue?vue&type=template&id=708f75d5&scoped=true&"
import script from "./tellaintlcjis.vue?vue&type=script&lang=js&"
export * from "./tellaintlcjis.vue?vue&type=script&lang=js&"
import style0 from "./tellaintlcjis.vue?vue&type=style&index=0&id=708f75d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f75d5",
  null
  
)

export default component.exports